module.exports = __webpack_public_path__ + "static/img/pingtai.64b7cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/pingtai.png
// module id = OJsl
// module chunks = 1